import { useState, useEffect, useMemo } from 'react';
import Icon from '../Assets/Icon/CustomIcons';

const weatherConfig = {
  Clear: { icon: Icon.LightMode, color: '#F59E0B', bg: '#FEF3C7' },
  Clouds: { icon: Icon.Cloud, color: '#64748B', bg: '#E2E8F0' },
  Rain: { icon: Icon.Rainy, color: '#3B82F6', bg: '#DBEAFE' },
  default: { icon: Icon.LightMode, color: '#F59E0B', bg: '#FEF3C7' },
};

const DEFAULT_LAT = 37.5665;
const DEFAULT_LON = 126.978;

const useWeather = () => {
  const [weatherData, setWeatherData] = useState({
    current: { temp: '--', condition: 'default' },
    tomorrow: { temp: '--', condition: 'default' },
  });

  useEffect(() => {
    const API_KEY = process.env.REACT_APP_WEATHER_API_KEY;

    const fetchWeather = async (lat, lon) => {
      const url = `https://api.openweathermap.org/data/2.5/forecast?lat=${lat}&lon=${lon}&appid=${API_KEY}&units=metric`;

      try {
        const response = await fetch(url);
        const data = await response.json();

        if (data.list && data.list.length > 0) {
          const current = data.list[0];
          const tomorrow = data.list[8] || data.list[data.list.length - 1];

          setWeatherData({
            current: {
              temp: Math.round(current.main.temp),
              condition: current.weather[0].main,
            },
            tomorrow: {
              temp: Math.round(tomorrow.main.temp),
              condition: tomorrow.weather[0].main,
            },
          });
        }
      } catch (err) {
        console.error('Weather Fetch Error:', err);
      }
    };

    const getLocation = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            fetchWeather(latitude, longitude);
          },
          (error) => {
            console.warn(
              '위치 정보를 가져올 수 없어 기본 위치를 사용합니다.',
              error
            );
            fetchWeather(DEFAULT_LAT, DEFAULT_LON);
          },
          { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
        );
      } else {
        console.warn('이 브라우저는 위치 서비스를 지원하지 않습니다.');
        fetchWeather(DEFAULT_LAT, DEFAULT_LON);
      }
    };

    getLocation();
  }, []);

  return useMemo(() => {
    const currentCfg =
      weatherConfig[weatherData.current.condition] || weatherConfig.default;
    const tomorrowCfg =
      weatherConfig[weatherData.tomorrow.condition] || weatherConfig.default;

    return {
      currentTemp: weatherData.current.temp,
      CurrentIcon: currentCfg.icon,
      currentColor: currentCfg.color,
      currentBg: currentCfg.bg,

      tomorrowTemp: weatherData.tomorrow.temp,
      TomorrowIcon: tomorrowCfg.icon,
      tomorrowColor: tomorrowCfg.color,
      tomorrowBg: tomorrowCfg.bg,
    };
  }, [weatherData]);
};

export default useWeather;
